/**
 * The admin API encrypts every non-string value, so a boolean comes back as the string "true" / "false",
 * and "false" is truthy. Always read API flags through this helper instead of testing them directly.
 * @param {boolean|string|null|undefined} value
 * @returns {boolean}
 */
export const isApiTrue = (value) => value === true || value === "true";
